import { defineStyleConfig } from "@chakra-ui/react";

export const Style = defineStyleConfig({
  baseStyle: {
    fontFamily: "Montserrat Alternates, sans-serif",
    justifyContent: "center",
    alignItems: "center",
    _focusVisible: { boxShadow: "none", outline: "none" },
    borderRadius: "30px",
    margin: 0,
    fontSize: { base: "17px", md: "1.66vw", "2xl": "56px" },
    lineHeight: "24px",
    fontWeight: 500,
    cursor: "pointer",
    svg: {
      cursor: "pointer",
    },
  },
  sizes: {
    // default button size
    sm: {
      fontSize: { base: "17px", "2xl": "56px" },
      fontWeight: 350,
      lineHeight: "24px",
    },
    md: {
      // переопределение шрифтов, отступов и размеров работает только здесь и в variants
      fontSize: "17px",
      fontWeight: 500,
      lineHeight: "24px",
      p: { base: "18px 40px", md: "16px 40px" },
      h: { base: "60px", md: "56px" },
    },
    //TODO rename this names S, M, L
    onlyIcon: {
      fontSize: 0,
      padding: "7px 7px",
      borderRadius: "8px",
      gap: 0,
      height: "30px",
      iconSpacing: 0,
      ".chakra-button__icon": {
        margin: "0",
      },
    },
    M: {
      fontSize: "14px",
      lineHeight: "20px",
      padding: "5px 8px",
      borderRadius: "8px",
      gap: "4px",
      height: "30px",
    },
  },
  variants: {
    primary: {
      bgColor: "ButtonBlue",
      color: "White",
      fontSize: { base: "17px", md: "1.66vw" },
      fontWeight: 700,
      height: { base: "52px", md: "61px", "2xl": "120px" },
      padding: "16px 32px",

      "@media(hover: hover)": {
        _hover: {
          bg: "linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), #2876FE",
          color: "White",
          _disabled: {
            bgColor: "Gray.3",
            color: "Gray.6",
          },
        },
      },
      "@media(hover: none)": {
        _hover: {
          bgColor: "SuperGreenDark",
          color: "White",
          _disabled: {
            bgColor: "Gray.6",
            color: "Gray.3",
          },
        },
      },
      _disabled: {
        bgColor: "Gray.6",
        color: "White",
        opacity: 1,
      },
      _active: {
        bgColor: "SuperGreen",
        color: "white",
      },
      _focus: {
        bgColor: "SuperGreenDark",
        color: "white",
        _disabled: {
          bgColor: "Gray.3",
          color: "Gray.6",
        },
      },
    },
    secondary: {
      bgColor: "ButtonBlue",
      color: "White",
      fontSize: "1.1111vw",
      height: { base: "52px", xl: "72px" },
      "@media(hover: hover)": {
        _hover: {
          bg: "linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), #2876FE",
          color: "White",
          _disabled: {
            bgColor: "Gray.3",
            color: "Gray.6",
          },
        },
      },
      "@media(hover: none)": {
        _hover: {
          bgColor: "SuperGreenDark",
          color: "White",
          _disabled: {
            bgColor: "Gray.6",
            color: "Gray.3",
          },
        },
      },
      _disabled: {
        bgColor: "Gray.6",
        color: "White",
        opacity: 1,
      },
      _active: {
        bgColor: "SuperGreen",
        color: "white",
      },
      _focus: {
        bgColor: "SuperGreenDark",
        color: "white",
        _disabled: {
          bgColor: "Gray.3",
          color: "Gray.6",
        },
      },
    },

    tertiary: {
      bgColor: "White",
      color: "Black.1",
      "@media(hover: hover)": {
        _hover: {
          bgColor: "Gray.1",
          color: "Black.1",
          _disabled: {
            bgColor: "White",
            color: "Gray.5",
          },
        },
      },
      _disabled: {
        bgColor: "White",
        color: "Gray.5",
      },
    },
    quaternary: {
      bgColor: "Gray.3",
      color: "Black.1",
      "@media(hover: hover)": {
        _hover: {
          bgColor: "Gray.4",
          color: "Black.1",
          _disabled: {
            bgColor: "Gray.3",
            color: "Black.6",
          },
        },
      },
      _disabled: {
        bgColor: "Gray.3",
        color: "Black.6",
      },
    },
    editorButton: {
      bgColor: "White",
      color: "Black.1",
      _active: {
        bgColor: "SuperGreen",
        color: "White",
        "@media(hover: hover)": {
          _hover: {
            bgColor: "SuperGreenDark",
            color: "White",
          },
        },
      },
      "@media(hover: hover)": {
        _hover: {
          bgColor: "#F7F7F7",
          color: "Black.1",
          _disabled: {
            bgColor: "Gray.3",
            color: "Black.6",
          },
        },
      },
      _disabled: {
        bgColor: "Gray.3",
        color: "Black.6",
      },
    },
    primarySupermoney: {
      bgColor: "#16A881",
      color: "#fff",
      "@media(hover: hover)": {
        _hover: {
          bgColor: "Green",
          color: "White",
          _disabled: {
            bgColor: "Gray.6",
            color: "Gray.5",
          },
        },
      },
    },
    primaryCircle: {
      bgColor: "SuperGreen",
      color: "White",
      borderRadius: "50%",
      "@media(hover: hover)": {
        _hover: {
          bgColor: "SuperGreenDark",
          color: "White",
          _disabled: {
            bgColor: "Gray.3",
            color: "Gray.6",
          },
        },
      },
    },
    secondaryCircle: {
      bgColor: "White",
      color: "Black.1",
      borderRadius: "50%",
      "@media(hover: hover)": {
        _hover: {
          bgColor: "Gray.1",
          color: "White",
          _disabled: {
            bgColor: "Black.1",
            color: "Black.3",
          },
        },
      },
    },
    imageEditorHeader: {
      bgColor: "SuperGreen",
      color: "White",
      borderRadius: "32px",
      _disabled: {
        bgColor: "Black.2",
        background: "Black.2",
        color: "rgba(255, 255, 255, 0.56)",
      },
    },
    store: {
      borderRadius: "5px",
      maxHeight: "40px",
      _hover: {
        bgColor: "transparent",
      },
    },
    undoRedo: {
      width: { base: "auto", md: "40px" },
      height: { base: "auto", md: "36px" },
      bgColor: { base: "transparent", md: "white" },
      color: { base: "Gray.6", md: "Gray.6" },
      borderRadius: "0px 20px 20px 0px !important",
      zIndex: 1000,
      rounded: "full",
      _hover: {
        color: { base: "#414141", md: "#Gray.3" },
      },
      _active: {
        color: { base: "white", md: "#414141" },
      },
      _focus: {
        color: { base: "white", md: "#414141" },
        opacity: 1,
      },
    },
    defaultProps: {
      variant: "primary",
    },
  },
});

export const ButtonStyle = {
  key: "Button",
  style: Style,
};
